<template>
  <div class="me">
    <app-cells>
      <h1 class="title">{{ user_info.first_name }} {{ user_info.last_name || '' }} ID: {{ user_info.id }}</h1>
    </app-cells>
    <div class="me__wrapper">
      <div class="me__name">
        <img alt="personal" src="@/assets/img/personal-details.svg">
        <span>Personal details</span>
      </div>
      <div class="me__row">
        <app-form-group label="Username">
          <app-input
            v-model="user_info.username"
            readonly
          />
        </app-form-group>
        <app-form-group label="Groups">
          <app-select
            v-model="user_info.groups"
            :options="[]"
            :clearable="false"
            class="select--multiple"
            multiple
            readonly
          />
        </app-form-group>
        <app-form-group label="Employee">
          <app-input
            v-model="user_info.employee"
            readonly
          />
        </app-form-group>
      </div>
      <div class="me__row">
        <app-form-group label="Email">
          <app-input
            v-model="user_info.email"
            readonly
          />
        </app-form-group>
        <app-form-group label="Phone number">
          <app-phone
            v-model="user_info.phone"
            default_сountry="TZ"
            readonly
          />
        </app-form-group>
        <app-form-group class="form-group--center" label="Other communications">
          <app-cells :indent="false">
            <app-checkbox
              v-model="user_info.phone_telegram"
              label="Telegram"
              readonly
            />
            <app-checkbox
              v-model="user_info.phone_whatsapp"
              label="Whatsapp"
              readonly
            />
          </app-cells>
        </app-form-group>
      </div>
      <div class="me__row">
        <app-form-group label="Telegram ID">
          <app-input
            v-model="user_info.telegram_id"
            readonly
          />
        </app-form-group>
        <app-form-group class="form-group--switcher" label="2FA">
          <app-switcher v-model="user_info.is_2fa_enabled" :readonly="is_2fa_readonly" @change.native="on2FAChanged"/>
        </app-form-group>
      </div>
    </div>
    <div v-if="is_sales_manager" class="lead-managers">
      <app-cells>
        <h2 class="title">Sales</h2>
        <div class="date-picker-wrapper">
          <VueCtkDateTimePicker
            id="date_picker_sales"
            ref="date_picker"
            v-model="filter_dates"
            :custom-shortcuts="custom_shortcuts"
            button-color="#77b017"
            class="custom-date-time-picker custom-date-time-picker--range"
            color="#77b017"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select dates"
            locale="en"
            no-header
            no-label
            overlay
            range
            shortcut="thisMonth"
            @input="onInputPicker"
            @is-hidden="onFetchAnalyticSales"
          />
        </div>
      </app-cells>
      <div class="lead-managers__holder">
        <app-spinner v-if="!is_loaded"/>
        <div v-else class="lead-managers__part">
          <div class="lead-managers__manager lead-managers__fstart">
            <div class="lead-managers__photo">
              <div class="lead-managers__avatar">
                <img :src="getUserAvatar(manager_sales_analytic.manager.crop.crop_url)" alt="Avatar">
              </div>
              <div class="lead-managers__info">
                <span class="lead-managers__name">{{ manager_sales_analytic.manager.full_name }}</span>
                <span class="lead-managers__position">Sales manager</span>
                <span class="lead-managers__seniority">{{
                    manager_sales_analytic.seniority || 'No employment date'
                  }}</span>
              </div>
            </div>
            <div class="lead-managers__conversion lead-managers__fstart">
              <div class="lead-managers__conversion-grid">
                <strong>Total sales</strong>
                <strong>Upcoming</strong>
                <strong>Completed</strong>
                <strong>Postponed</strong>
                <strong>Count</strong>
                <div class="lead-managers__amount">
                  <img alt="Amount" src="@/assets/img/lead-amount.svg">
                  <span class="lead-managers__row-value">{{
                      manager_sales_analytic.total_sales.amount.toLocaleString()
                    }}$</span>
                </div>
                <div class="lead-managers__amount">
                  <img alt="Amount" src="@/assets/img/lead-amount.svg">
                  <span class="lead-managers__row-value">{{
                      manager_sales_analytic.confirmed.amount.toLocaleString()
                    }}$</span>
                </div>
                <div class="lead-managers__amount">
                  <img alt="Amount" src="@/assets/img/lead-amount.svg">
                  <span class="lead-managers__row-value">{{
                      manager_sales_analytic.completed.amount.toLocaleString()
                    }}$</span>
                </div>
                <div class="lead-managers__amount">
                  <img alt="Amount" src="@/assets/img/lead-amount.svg">
                  <span class="lead-managers__row-value">{{
                      manager_sales_analytic.postponed.amount.toLocaleString()
                    }}$</span>
                </div>
                <div class="lead-managers__conversion-line">
                  <span>Requests:</span><b>{{ manager_sales_analytic.total_sales.count }}</b></div>
                <div class="lead-managers__amount">
                  <img alt="Commission" src="@/assets/img/lead-commission.svg">
                  <span class="lead-managers__row-value">{{
                      manager_sales_analytic.total_sales.commission.toLocaleString()
                    }}$</span>
                </div>
                <div class="lead-managers__amount">
                  <img alt="Commission" src="@/assets/img/lead-commission.svg">
                  <span class="lead-managers__row-value">{{
                      manager_sales_analytic.confirmed.commission.toLocaleString()
                    }}$</span>
                </div>
                <div class="lead-managers__amount">
                  <img alt="Commission" src="@/assets/img/lead-commission.svg">
                  <span class="lead-managers__row-value">{{
                      manager_sales_analytic.completed.commission.toLocaleString()
                    }}$</span>
                </div>
                <div class="lead-managers__amount">
                  <img alt="Commission" src="@/assets/img/lead-commission.svg">
                  <span class="lead-managers__row-value">{{
                      manager_sales_analytic.postponed.commission.toLocaleString()
                    }}$</span>
                </div>
                <div></div>
                <div class="lead-managers__row-amount">
                  <img alt="Discount" src="@/assets/img/lead-discount.svg">
                  <span class="lead-managers__row-value">{{
                      manager_sales_analytic.total_sales.discounts.toLocaleString()
                    }}$</span>
                </div>
              </div>
            </div>
          </div>
          <div class="lead-managers__table lead-managers__table--grid">
            <div v-for="(status, index) of status_list_sales" :key="status.name" class="lead-managers__row-holder">
              <button class="lead-managers__row-head"
                      type="button"
                      @click="manager_sales_analytic[status.fieldName].show_activities = !manager_sales_analytic[status.fieldName].show_activities">
                <span>
                  <span :style="{ 'backgroundColor': status.color }"
                        class="lead-managers__row-value lead-managers__row-value--tag">{{ status.name }}</span>
                </span>
                <span class="lead-managers__row-value">{{
                    manager_sales_analytic[status.fieldName].count
                  }} ({{ manager_sales_analytic[status.fieldName].pax }})</span>
                <div class="lead-managers__row-amounts">
                  <div class="lead-managers__row-amount">
                    <img alt="Amount" src="@/assets/img/lead-amount.svg">
                    <span class="lead-managers__row-value">{{
                        manager_sales_analytic[status.fieldName].amount.toLocaleString()
                      }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img alt="Commission" src="@/assets/img/lead-commission.svg">
                    <span class="lead-managers__row-value">{{
                        manager_sales_analytic[status.fieldName].commission.toLocaleString()
                      }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img alt="Discount" src="@/assets/img/lead-discount.svg">
                    <span class="lead-managers__row-value">{{
                        manager_sales_analytic[status.fieldName].discounts.toLocaleString()
                      }}$</span>
                  </div>
                </div>
                <span :class="{'lead-managers__row-switcher--show': manager_sales_analytic[status.fieldName].show_activities}"
                      class="lead-managers__row-switcher"></span>
              </button>
              <div
                :class="{
                  'lead-managers__row-activities--show': manager_sales_analytic[status.fieldName].show_activities,
                  'lead-managers__row-activities--left': index === 0,
                  'lead-managers__row-activities--right': index === 1
                }"
                class="lead-managers__row-activities"
              >
                <div class="lead-managers__row-activities-row">
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Amount" src="@/assets/img/lead-climbing.svg">
                      <span class="lead-managers__row-value">Climbing:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Climbing" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.climbing.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.climbing.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Safari" src="@/assets/img/lead-safari.svg">
                      <span class="lead-managers__row-value">Safari:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Commission" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.safari.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.safari.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                </div>
                <div class="lead-managers__row-activities-row">
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Amount" src="@/assets/img/lead-daytrips.svg">
                      <span class="lead-managers__row-value">Daytrips:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Climbing" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.daytrips.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.daytrips.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Safari" src="@/assets/img/lead-islands.svg">
                      <span class="lead-managers__row-value">Islands:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Commission" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.islands.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.islands.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                </div>
                <div class="lead-managers__row-activities-row">
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Amount" src="@/assets/img/lead-transfers.svg">
                      <span class="lead-managers__row-value">Transfers:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Climbing" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.transfers.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.transfers.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Safari" src="@/assets/img/lead-flight.svg">
                      <span class="lead-managers__row-value">Flights:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Commission" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.flights.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.flights.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                </div>
                <div class="lead-managers__row-activities-row">
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Amount" src="@/assets/img/lead-hotels.svg">
                      <span class="lead-managers__row-value">Hotels:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Climbing" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.extra_accommodation.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.extra_accommodation.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Safari" src="@/assets/img/lead-services.svg">
                      <span class="lead-managers__row-value">Services:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Commission" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.additional_services.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.additional_services.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                </div>
                <div class="lead-managers__row-activities-row">
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Amount" src="@/assets/img/lead-airport.svg">
                      <span class="lead-managers__row-value">Airport VIP:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Climbing" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.airport_vip_service.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.airport_vip_service.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Safari" src="@/assets/img/lead-other.svg">
                      <span class="lead-managers__row-value">Other:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Commission" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.other.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_sales_analytic[status.fieldName].activities.other.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-cells>
        <h2 class="title">Requests</h2>
        <div class="date-picker-wrapper">
          <VueCtkDateTimePicker
            id="date_picker_request"
            ref="date_picker_request"
            v-model="filter_dates_request"
            :custom-shortcuts="custom_shortcuts"
            button-color="#77b017"
            class="custom-date-time-picker custom-date-time-picker--range"
            color="#77b017"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select dates"
            locale="en"
            no-header
            no-label
            overlay
            range
            shortcut="last60Days"
            @input="onInputPickerRequest"
            @is-hidden="onFetchAnalyticRequest"
          />
        </div>
      </app-cells>
      <div class="lead-managers__holder">
        <app-spinner v-if="!is_loaded_request"/>
        <div v-else class="lead-managers__part">
          <div class="lead-managers__manager lead-managers__fstart">
            <div class="lead-managers__photo">
              <div class="lead-managers__avatar">
                <img :src="getUserAvatar(manager_analytic.manager.crop.crop_url)" alt="Avatar">
              </div>
              <div class="lead-managers__info">
                <span class="lead-managers__name">{{ manager_analytic.manager.full_name }}</span>
                <span class="lead-managers__position">Sales manager</span>
                <span class="lead-managers__seniority">{{ manager_analytic.seniority || 'No employment date' }}</span>
              </div>
            </div>
            <div class="lead-managers__conversion lead-managers__fstart">
              <div class="lead-managers__diagram">
                <div :class="{'over50': manager_analytic.conversion.rate >= 50}"
                     class="lead-managers__diagram-piece left"></div>
                <div :class="{'over50': manager_analytic.conversion.rate >= 50}"
                     :style="{'transform': `rotate(${(360 * manager_analytic.conversion.rate / 100) + 180}deg)` }"
                     class="lead-managers__diagram-piece right"></div>
                <span class="lead-managers__diagram-text">{{ manager_analytic.conversion.rate }}%</span>
              </div>
              <div class="lead-managers__conversion-grid lead-managers__conversion-grid--4">
                <strong>Conversion rate</strong>
                <strong>Total sales</strong>
                <strong>Upcoming</strong>
                <strong>Completed</strong>
                <div class="lead-managers__conversion-line">
                  <span>Requests:</span><b>{{ manager_analytic.conversion.requests }}</b></div>
                <div class="lead-managers__amount">
                  <img alt="Amount" src="@/assets/img/lead-amount.svg">
                  <span class="lead-managers__row-value">{{
                      manager_analytic.total_sales.amount.toLocaleString()
                    }}$</span>
                </div>
                <div class="lead-managers__amount">
                  <img alt="Amount" src="@/assets/img/lead-amount.svg">
                  <span class="lead-managers__row-value">{{
                      manager_analytic.confirmed.amount.toLocaleString()
                    }}$</span>
                </div>
                <div class="lead-managers__amount">
                  <img alt="Amount" src="@/assets/img/lead-amount.svg">
                  <span class="lead-managers__row-value">{{
                      manager_analytic.completed.amount.toLocaleString()
                    }}$</span>
                </div>
                <div class="lead-managers__conversion-line">
                  <span>Confirmed:</span><b>{{ manager_analytic.conversion.confirmed }}</b></div>
                <div class="lead-managers__amount">
                  <img alt="Commission" src="@/assets/img/lead-commission.svg">
                  <span class="lead-managers__row-value">{{
                      manager_analytic.total_sales.commission.toLocaleString()
                    }}$</span>
                </div>
                <div class="lead-managers__amount">
                  <img alt="Commission" src="@/assets/img/lead-commission.svg">
                  <span class="lead-managers__row-value">{{
                      manager_analytic.confirmed.commission.toLocaleString()
                    }}$</span>
                </div>
                <div class="lead-managers__amount">
                  <img alt="Commission" src="@/assets/img/lead-commission.svg">
                  <span class="lead-managers__row-value">{{
                      manager_analytic.completed.commission.toLocaleString()
                    }}$</span>
                </div>
                <div></div>
                <div class="lead-managers__amount">
                  <img alt="Commission" src="@/assets/img/lead-discount.svg">
                  <span class="lead-managers__row-value">{{
                      manager_analytic.total_sales.discounts.toLocaleString()
                    }}$</span>
                </div>
              </div>
            </div>
          </div>
          <div class="lead-managers__table lead-managers__table--grid">
            <div v-for="(status, index) of status_list_request" :key="status.name" class="lead-managers__row-holder">
              <button class="lead-managers__row-head"
                      type="button"
                      @click="manager_analytic[status.fieldName].show_activities = !manager_analytic[status.fieldName].show_activities">
                <span>
                  <span :style="{ 'backgroundColor': status.color }"
                        class="lead-managers__row-value lead-managers__row-value--tag">{{ status.name }}</span>
                </span>
                <span class="lead-managers__row-value">{{
                    manager_analytic[status.fieldName].count
                  }} ({{ manager_analytic[status.fieldName].pax }})</span>
                <div class="lead-managers__row-amounts">
                  <div class="lead-managers__row-amount">
                    <img alt="Amount" src="@/assets/img/lead-amount.svg">
                    <span class="lead-managers__row-value">{{
                        manager_analytic[status.fieldName].amount.toLocaleString()
                      }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img alt="Commission" src="@/assets/img/lead-commission.svg">
                    <span class="lead-managers__row-value">{{
                        manager_analytic[status.fieldName].commission.toLocaleString()
                      }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img alt="Discount" src="@/assets/img/lead-discount.svg">
                    <span class="lead-managers__row-value">{{
                        manager_analytic[status.fieldName].discounts.toLocaleString()
                      }}$</span>
                  </div>
                </div>
                <span :class="{'lead-managers__row-switcher--show': manager_analytic[status.fieldName].show_activities}"
                      class="lead-managers__row-switcher"></span>
              </button>
              <div
                :class="{
                  'lead-managers__row-activities--show': manager_analytic[status.fieldName].show_activities,
                  'lead-managers__row-activities--left': index === 8,
                  'lead-managers__row-activities--right': index === 9
                }"
                class="lead-managers__row-activities"
              >
                <div class="lead-managers__row-activities-row">
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Amount" src="@/assets/img/lead-climbing.svg">
                      <span class="lead-managers__row-value">Climbing:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Climbing" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.climbing.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.climbing.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Safari" src="@/assets/img/lead-safari.svg">
                      <span class="lead-managers__row-value">Safari:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Commission" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.safari.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.safari.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                </div>
                <div class="lead-managers__row-activities-row">
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Amount" src="@/assets/img/lead-daytrips.svg">
                      <span class="lead-managers__row-value">Daytrips:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Climbing" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.daytrips.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.daytrips.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Safari" src="@/assets/img/lead-islands.svg">
                      <span class="lead-managers__row-value">Islands:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Commission" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.islands.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.islands.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                </div>
                <div class="lead-managers__row-activities-row">
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Amount" src="@/assets/img/lead-transfers.svg">
                      <span class="lead-managers__row-value">Transfers:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Climbing" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.transfers.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.transfers.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Safari" src="@/assets/img/lead-flight.svg">
                      <span class="lead-managers__row-value">Flights:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Commission" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.flights.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.flights.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                </div>
                <div class="lead-managers__row-activities-row">
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Amount" src="@/assets/img/lead-hotels.svg">
                      <span class="lead-managers__row-value">Hotels:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Climbing" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.extra_accommodation.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.extra_accommodation.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Safari" src="@/assets/img/lead-services.svg">
                      <span class="lead-managers__row-value">Services:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Commission" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.additional_services.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.additional_services.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                </div>
                <div class="lead-managers__row-activities-row">
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Amount" src="@/assets/img/lead-airport.svg">
                      <span class="lead-managers__row-value">Airport VIP:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Climbing" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.airport_vip_service.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.airport_vip_service.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                  <div class="lead-managers__row-amounts">
                    <div class="lead-managers__row-amount">
                      <img alt="Safari" src="@/assets/img/lead-other.svg">
                      <span class="lead-managers__row-value">Other:</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Commission" src="@/assets/img/lead-amount.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.other.amount.toLocaleString()
                        }}$</span>
                    </div>
                    <div class="lead-managers__row-amount">
                      <img alt="Discount" src="@/assets/img/lead-commission.svg">
                      <span class="lead-managers__row-value">{{
                          manager_analytic[status.fieldName].activities.other.commission.toLocaleString()
                        }}$</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <sales-leave-self-service v-if="user_info.employee && can_use_sales_leave" />
    </div>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="326"
      class="modal-not-overflow"
      draggable=".popup__title"
      name="2fa-popup"
    >
      <div class="popup">
        <button class="popup__close" type="button" @click="onPopupClose"></button>
        <div class="popup__title">Setting up 2FA</div>
        <div class="popup__subt">Scan QR code below with any auth app</div>
        <div class="popup__body">
          <VueQRCodeComponent :text="otpath"></VueQRCodeComponent>
          <app-input
            v-model="password"
            placeholder="Enter 6 digit code from auth app"
            style="margin-top: 20px"
            type="number"
            @input.native="onPasswordChanged"
          />
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getLeadsAnalyticsRequestPersonal,
  getLeadsAnalyticsSalesPersonal,
  postTOTPCreate,
  postTOTPVerify,
} from '@/http'
import VueQRCodeComponent from 'vue-qrcode-component'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import SalesLeaveSelfService from '@/views/employees/sales-leave/SalesLeaveSelfService'

export default {
  name: 'Me',
  components: { VueQRCodeComponent, VueCtkDateTimePicker, SalesLeaveSelfService },
  data() {
    return {
      is_2fa_readonly: false,
      otpath: null,
      password: null,
      manager_analytic: null,
      manager_sales_analytic: null,
      filter_dates: null,
      filter_dates_request: null,
      custom_shortcuts: [
        { key: 'thisMonth', label: 'This month', value: 'month' },
        { key: 'lastMonth', label: 'Last month', value: '-month' },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'last180Days', label: 'Last 180 days', value: 180 },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' }
      ],
      custom_shortcuts_request: [
        { key: 'last7Days', label: 'Last 7 days', value: 7 },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'last180Days', label: 'Last 180 days', value: 180 },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' }
      ],
      status_list_sales: [
        { name: 'Deposit paid', fieldName: 'deposit', color: '#3DC5C5' },
        { name: 'Full paid', fieldName: 'full_paid', color: '#256DC1' }
      ],
      status_list_request: [
        { name: 'Lead', fieldName: 'lead', color: '#1DB748' },
        { name: 'Nurture', fieldName: 'nurture', color: '#000080' },
        { name: 'Negotiation', fieldName: 'negotiation', color: '#DD5082' },
        { name: 'Pre confirmed', fieldName: 'pre_confirmed', color: '#A95AC5' },
        { name: 'Deposit paid', fieldName: 'deposit', color: '#3DC5C5' },
        { name: 'Full paid', fieldName: 'full_paid', color: '#256DC1' },
        { name: 'Postponed', fieldName: 'postponed', color: '#DEA000' },
        { name: 'Refused', fieldName: 'refused', color: '#E85C20' },
        { name: 'No response', fieldName: 'no_response', color: '#FC9721' },
        { name: 'Lost', fieldName: 'lost', color: '#E85C20' }
      ],
      is_loaded: false,
      is_loaded_request: false
    }
  },
  computed: {
    user_info() {
      return this.$store.state.userData
    },
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    can_use_sales_leave() {
      const roles = this.$store.state.userGroups.map(item => item.code)
      return ['sales_manager', 'sales_supervisor', 'marketing_supervisor'].some(role => roles.includes(role))
    }
  },
  created() {
    if (this.user_info.employee) {
      this.user_info.employee = this.user_info.employee.full_name
    }
    if (this.user_info.is_2fa_enabled) this.is_2fa_readonly = true
    if (this.is_sales_manager && this.filter_dates) this.onFetchAnalyticSales()
    if (this.is_sales_manager && this.filter_dates_request) this.onFetchAnalyticRequest()
  },
  methods: {
    onFetchAnalyticRequest() {
      getLeadsAnalyticsRequestPersonal({ from_date: this.filter_dates?.start, to_date: this.filter_dates?.end })
        .then(response => {
          this.manager_analytic = response.data
          this.is_loaded_request = true
        })
    },
    onFetchAnalyticSales() {
      getLeadsAnalyticsSalesPersonal({ from_date: this.filter_dates?.start, to_date: this.filter_dates?.end })
        .then(response => {
          this.manager_sales_analytic = response.data
          this.is_loaded = true
        })
    },
    onInputPicker() {
      if (!this.$refs.date_picker.pickerOpen) this.onFetchAnalyticSales()
    },
    onInputPickerRequest() {
      if (!this.$refs.date_picker_request.pickerOpen) this.onFetchAnalyticRequest()
    },
    onPasswordChanged() {
      if (this.password.length === 6) {
        postTOTPVerify(this.password)
          .then(() => {
            this.$modal.hide('2fa-popup')
            return this.$store.dispatch('permissions/refreshProfile', true)
          })
          .catch(() => {
            this.password = null
          })
      }
    },
    on2FAChanged() {
      if (this.user_info.is_2fa_enabled) {
        postTOTPCreate().then(res => {
          this.otpath = res.data
          this.$modal.show('2fa-popup')
        })
      }
    },
    onPopupClose() {
      this.user_info.is_2fa_enabled = false
      this.$modal.hide('2fa-popup')
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug2.jpg')
    }
  }
}
</script>

<style lang="sass" scoped>
.me__wrapper
  max-width: 1080px

.me__name
  display: flex
  align-items: center
  gap: 10px
  margin-bottom: 25px
  color: #181818
  font-weight: 500

.me__row
  display: grid
  grid-template-columns: repeat(3, 1fr)
  gap: 10px 20px
  margin-bottom: 20px
</style>
